const urlEndpoint = "/campaign?promotion=qrCode&method=registerQrPromo";

export const redeemPromo = async (
  accessToken,
  setPromoState,
  openRedeemModal
) => {
  setPromoState((prevState) => ({
    ...prevState,
    loadingPromo: true,
  }));
  try {
    const res = await fetch(process.env.REACT_APP_API_URL + urlEndpoint, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });
    const response = await res.json();
    if (response.cod === "200") {
      setPromoState((prevState) => ({
        ...prevState,
        loadingPromo: false,
        alreadyTaken: true,
        error: false,
      }));
    } else {
      setPromoState((prevState) => ({
        ...prevState,
        loadingPromo: false,
        expiredPromo: true,
        alreadyTaken: true,
        error: false,
      }));
    }
    openRedeemModal();
  } catch (error) {
    console.log(error);
    setPromoState((prevState) => ({
      ...prevState,
      loadingPromo: false,
      error: true,
      errorMessage: error?.message || "Something went wrong",
    }));
  }
};
